<template>
    <div class="info-record" :class="[type]">{{ content }}</div>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
        },
        type: {
            type: String,
            default() { return 'left' },
            validator: s => ['left', 'right'].includes(s)
        }
    }
}
</script>
<style lang="scss" scoped>
.info-record {
    font-size: 14px;
    padding: 7px 10px;
    border-radius: 6px;
    position: relative;
    margin-top: 5px;
    &.left {
        background: #dee0e3;
        &::before {
            position: absolute;
            left: -8px;
            top: 50%;
            transform: translate(0, -50%);
            content: "";
            border-right: 10px solid #dee0e3;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
        }
    }
    &.right {
        top: 0;
        right: 0;
        margin-right: 10px;
        background: #4996F6;
        color: #D7E8FD;
        text-align: left;
        &::after {
           position: absolute;
            right: -8px;
            top: 50%;
            transform: translate(0,-50%);
            content: "";
            border-left: 10px solid #4996F6;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
        }
    }
}
</style>